/**
 * De twee pictogrammen die Retouren en Reviews extra nodig hebben.
 *
 * De set van bouwer 1 (`../Vandaag/pictogrammen`) draagt mail, euro,
 * klok, schild en de rest; die importeer ik daar, ik kopieer ze niet.
 * Alleen wat er nog niet is staat hier. Eigen lijn-SVG's, geen emoji en
 * geen icoonfont — zo staat het in het designsysteem.
 */

interface Props {
  maat?: number;
}

function Basis({
  maat = 14,
  children,
}: Props & { children: React.ReactNode }) {
  return (
    <svg
      viewBox="0 0 24 24"
      width={maat}
      height={maat}
      fill="none"
      stroke="currentColor"
      strokeWidth={1.8}
      strokeLinecap="round"
      strokeLinejoin="round"
      aria-hidden="true"
      focusable="false"
    >
      {children}
    </svg>
  );
}

/** Plus, voor "Retourlabel maken". */
export function IcoonPlus(props: Props) {
  return (
    <Basis {...props}>
      <path d="M12 5v14" />
      <path d="M5 12h14" />
    </Basis>
  );
}

/** De retourpijl uit de mock (`#i-retour`). */
export function IcoonRetour(props: Props) {
  return (
    <Basis {...props}>
      <path d="M9 14L4 9l5-5" />
      <path d="M4 9h11a5 5 0 0 1 0 10h-4" />
    </Basis>
  );
}

/** Ster, voor Reviews. Gevuld als de review positief is. */
export function IcoonSter({ maat = 14, vol = false }: Props & { vol?: boolean }) {
  return (
    <svg
      viewBox="0 0 24 24"
      width={maat}
      height={maat}
      fill={vol ? "currentColor" : "none"}
      stroke="currentColor"
      strokeWidth={1.6}
      strokeLinecap="round"
      strokeLinejoin="round"
      aria-hidden="true"
      focusable="false"
    >
      <path d="M12 3l2.7 5.6 6.1.9-4.4 4.3 1 6.1L12 17l-5.4 2.9 1-6.1L3.2 9.5l6.1-.9z" />
    </svg>
  );
}
